import EmailActionRoutes from './EmailActionsRoutes'

const allVisibleRoutes = [...EmailActionRoutes]

export default allVisibleRoutes
